import * as React from 'react';
import styled from 'styled-components';
import { ArrowRight } from '@mui/icons-material';

import { getColor, getFontSize, getHeight } from '@process-advisor/process-miner/shared/theme';

const getOptionBorder = (isFirst: boolean, isLast: boolean): string =>
    `${isFirst ? '4px 4px' : '0 0'} ${isLast ? '4px 4px' : '0 0'}`;

export const StyledOption = styled.div<{ isFirst: boolean, isLast: boolean }>`
    display: flex;
    justify-content: space-between;
    gap: 5px;
    align-items: center;

    background-color: ${getColor('white')};
    padding: 7px 16px;
    height: ${getHeight('contextMenuOption')}px;
    border-radius: ${({ isFirst, isLast }) => getOptionBorder(isFirst, isLast)};

    transition: .25s;
    cursor: pointer;

    font-size: ${getFontSize('smaller')};
    font-weight: bold;
    white-space: nowrap;

    &:hover {
        background-color: ${getColor('lightestGray')};
    }
`;

type Props = {
    text: string,
    event?: () => void,
    isExpandable?: boolean,
    isFirst?: boolean,
    isLast?: boolean
}

export const Option = ({
    text,
    event,
    isExpandable = false,
    isFirst = false,
    isLast = false,
}: Props) => (
    <StyledOption isFirst={isFirst} isLast={isLast} onClick={event}>
        <div>{text}</div>
        {isExpandable && <ArrowRight />}
    </StyledOption>
);
